import { PHONE_VALIDATION_REG_EX } from '../constants/form/validation';

export const formatPhoneNumber = (phone: string): string => {
  if (PHONE_VALIDATION_REG_EX.test(phone)) {
    return phone;
  }

  const parsed = phone.match(/\+7(\d{3})(\d{3})(\d{2})(\d{2})/);

  if (!parsed) {
    throw new Error('Does not match the string! String must be like +79991234567');
  }

  return `+7 ${parsed[1]} ${parsed[2]}-${parsed[3]}-${parsed[4]}`;
};
